import { de, enGB, enUS, es, fr } from "date-fns/locale";
import { store } from "store/store";
const localeLanguage = {
    fr: fr,
    en: enUS,
    enUS: enUS,
    enGB: enGB,
    es: es,
    de: de,
};

/**
 * Hook for Mui Localization Provider, get the navigator language for adapterLocale prop
 * Exemple usage :
 * const adapterLocale = useAdapterLocale()
 * <LocalizationProvider adapterLocale={adapterLocale} />
 */
export const useAdapterLocale = () => {
    const navigatorLanguage = navigator.language.split("-")[0];
    return localeLanguage[navigatorLanguage] || fr;
};

export const selectLocales = () => store?.getState()?.locales?.locales || [];
